<div>
	<div class="ibox-title">
		<h5>Visitors Waiting for Verification ({{ Title }})</h5>
	</div>

	<div class="ibox-content">
		<!--Options-->
		<div class="ButtonGrid">
			<button
				[ngClass]="{
					btn: true,
					'btn-primary': OptionID != 0,
					'btn-warning': OptionID == 0
				}"
				(click)="SelectOption(0)"
			>
				Facility
			</button>

			<button
				[ngClass]="{
					btn: true,
					'btn-primary': OptionID != 1,
					'btn-warning': OptionID == 1
				}"
				(click)="SelectOption(1)"
			>
				District
			</button>
		</div>

		<!--Loading Overlay-->
		<div class="CenterDiv" *ngIf="Inited == false">
			<p-progressSpinner></p-progressSpinner>
		</div>

		<!--Table-->
		<div class="table-main-body" *ngIf="Inited == true">
			<p-table
				#mydt
				[value]="lstVisitorPass"
				[loading]="loading"
				[paginator]="true"
				[(rows)]="pagerows"
				[(first)]="pagefirst"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="single"
				[(selection)]="SelectedVisitorPass"
				dataKey="VisitorPassID"
				(onRowSelect)="onRowSelect($event)"
				(onRowUnselect)="onRowUnselect($event)"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10, 25, 50]"
			>
				<!--Headers-->
				<ng-template pTemplate="header">
					<!--Filter or Select from Dropdown-->
					<tr>
						<!--HasPhotoDesc-->
						<th class="ImageCol"></th>

						<!--FirstName-->
						<th>
							<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<!--LastName-->
						<th>
							<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<!--Destination-->
						<th>
							<p-columnFilter field="Destination" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown
										#filterDestination
										[ngModel]="value"
										[options]="lstDestination"
										(onChange)="filter($event.value)"
										placeholder="Any"
										[showClear]="true"
									>
										<ng-template let-value pTemplate="item">
											<span>{{ value }}</span>
										</ng-template>
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th>

						<!--VisitorReasonDesc-->
						<th>
							<p-columnFilter field="VisitorReasonDesc" matchMode="equals" [showMenu]="false">
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown
										#filterVisitorReasonDesc
										[ngModel]="value"
										[options]="lstVisitorReasonDesc"
										(onChange)="filter($event.value)"
										placeholder="Any"
										[showClear]="true"
									>
										<ng-template let-value pTemplate="item">
											<span>{{ value }}</span>
										</ng-template>
									</p-dropdown>
								</ng-template>
							</p-columnFilter>
						</th>

						<!--Comment-->
						<th>
							<p-columnFilter type="text" field="Comment" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>
					</tr>

					<!--Column Names-->
					<tr style="height: 4rem">
						<th class="ImageCol"></th>

						<!--INSERT CUSTOM COLUMNS HERE-->
						<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
						<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
						<th pSortableColumn="Destination">Destination<p-sortIcon field="Destination"></p-sortIcon></th>
						<th pSortableColumn="VisitorReasonDesc">Reason<p-sortIcon field="VisitorReasonDesc"></p-sortIcon></th>
						<th pSortableColumn="Comment">Notes<p-sortIcon field="Comment"></p-sortIcon></th>
					</tr>
				</ng-template>

				<!--Data-->
				<ng-template pTemplate="body" let-VisitorPass>
					<tr [pSelectableRow]="VisitorPass" (dblclick)="onRowDblClick(VisitorPass)">
						<td class="ImageCol">
							<a [id]="'Link' + VisitorPass.VisitorPassID" style="display: none" [routerLink]="VisitorPass.RouterLink" target="_blank"></a>
							<img class="VisitorImage" [src]="GetPhotoData(VisitorPass.VisitorPassID)" />
						</td>

						<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
							{{ VisitorPass[col.field] }}
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>
